(() => {
  const root = document.querySelector("[data-nami-consent]");
  if (!root) return;

  const previewParameter = root.dataset.previewParameter || "nami_consent_preview";
  const previewMode = new URLSearchParams(window.location.search).get(previewParameter) === "1";
  const summary = root.querySelector("[data-consent-summary]");
  const preferencesPanel = root.querySelector("[data-consent-preferences]");
  const manageButton = root.querySelector("[data-consent-manage]");
  const actionButtons = [...root.querySelectorAll("button")];
  let customerPrivacy = null;

  const setBusy = (busy) => {
    actionButtons.forEach((button) => {
      button.disabled = busy;
    });
  };

  const show = () => {
    root.hidden = false;
    window.requestAnimationFrame(() => {
      root.dataset.visible = "true";
    });
  };

  const hide = () => {
    root.dataset.leaving = "true";
    root.dataset.visible = "false";
    window.setTimeout(() => {
      root.hidden = true;
      delete root.dataset.leaving;
    }, 160);
  };

  const showSummary = () => {
    preferencesPanel.hidden = true;
    summary.hidden = false;
    manageButton.setAttribute("aria-expanded", "false");
    manageButton.focus({ preventScroll: true });
  };

  const hydrateSelection = () => {
    const currentConsent = customerPrivacy?.currentVisitorConsent?.();
    if (!currentConsent) return;

    root.querySelectorAll("[data-consent-option]").forEach((input) => {
      input.checked = currentConsent[input.dataset.consentOption] === "yes";
    });
  };

  const showPreferences = () => {
    hydrateSelection();
    summary.hidden = true;
    preferencesPanel.hidden = false;
    manageButton.setAttribute("aria-expanded", "true");
    preferencesPanel.querySelector("input:not(:disabled)")?.focus({ preventScroll: true });
  };

  const selectedConsent = () => {
    const selection = {};
    root.querySelectorAll("[data-consent-option]").forEach((input) => {
      selection[input.dataset.consentOption] = input.checked;
    });
    return selection;
  };

  const submitConsent = (selection) => {
    if (previewMode || !customerPrivacy?.setTrackingConsent) {
      hide();
      return;
    }

    setBusy(true);
    customerPrivacy.setTrackingConsent(selection, () => {
      setBusy(false);
      hide();
      document.dispatchEvent(new CustomEvent("nami:consent-updated", { detail: selection }));
    });
  };

  root.querySelector("[data-consent-accept]")?.addEventListener("click", () => {
    submitConsent({ analytics: true, marketing: true, preferences: true });
  });

  root.querySelector("[data-consent-reject]")?.addEventListener("click", () => {
    submitConsent({ analytics: false, marketing: false, preferences: false });
  });

  root.querySelector("[data-consent-save]")?.addEventListener("click", () => {
    submitConsent(selectedConsent());
  });

  manageButton?.addEventListener("click", showPreferences);
  root.querySelector("[data-consent-close-preferences]")?.addEventListener("click", showSummary);

  root.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !preferencesPanel.hidden) showSummary();
  });

  const initialize = (attempt = 0) => {
    if (!window.Shopify?.loadFeatures) {
      if (previewMode) show();
      if (attempt < 40) window.setTimeout(() => initialize(attempt + 1), 100);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      (error) => {
        if (error) {
          if (previewMode) show();
          return;
        }

        customerPrivacy = window.Shopify.customerPrivacy;
        if (previewMode || customerPrivacy?.shouldShowBanner?.()) show();
      },
    );
  };

  initialize();
})();
